module.exports = __webpack_public_path__ + "img/teaching-9.7c162a20.png";